define("media/engine", ["exports", "ember-engines/engine", "ember-load-initializers", "media/resolver", "media/config/environment"], function (_exports, _engine, _emberLoadInitializers, _resolver, _environment) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const {
    modulePrefix
  } = _environment.default;

  class Eng extends _engine.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "modulePrefix", modulePrefix);

      _defineProperty(this, "Resolver", _resolver.default);

      _defineProperty(this, "dependencies", {
        services: ['alerts', 'auth', 'cache', 'credential-status', 'credentials', 'dialogManager', 'dropbox', 'errors', 'googlePicker', 'intl', 'locale', 'mediaItemQuery', 'mediaItemUpload', 'mediaLabels', 'mediaLibrary', 'mediaNavigation', 'mediaUpload', 'perfectScroll', 'queryPersistence', 'router', 'schedule/caption-hashtags', 'secondaryModal', 'segment', 'starredMedia', 'store', 'subscriptions', 'uploadBus', 'userConfig'],
        externalRoutes: ['calendarMedia', 'contribute', 'schedule', 'account.groups', 'cluster.media', 'cluster.collect.unsplash']
      });
    }

  }

  (0, _emberLoadInitializers.default)(Eng, modulePrefix);
  var _default = Eng;
  _exports.default = _default;
});